import React from 'react'
import "./payment.css";
import {useStateValue} from "./StateProvider"
import { Link } from "react-router-dom";
import CheckoutProduct from './CheckoutProduct';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

function Payment() {
  const [{basket, user}, dispatch] = useStateValue();  
const stripe = useStripe()
const elements = useElements()

// const []


// const handleSubmit = e =>{
    
// }


// const handleChange = e =>{

// }
    return (
        <div className="payment">
            <div className="payment__container">
            <h1>Checkout {<Link to="/checkout">{basket?.length} items</Link>}</h1>
            {/* Delivery */}
            <div className="payment__section">
            <div className="payment__title">
            <h3>Delivery Address</h3>
            </div>
            <div className="payment__address">
            <p>{user?.email}</p>
            <p>B 1/3 Aliganj</p>
            <p>Lucknow</p>
            </div>
            </div>
            {/* Reviewing */}
            <div className="payment__section">
            <div className="payment__title">
            <h3>Review Items and Delivery</h3>
            </div>
       <div className="payment__items">
       {/* Items Basket  */}
       {basket.map(item => 
       <CheckoutProduct 
            id={item.id}
            title={item.title}
            image={item.image}
            price={item.price}
            rating={item.rating}
       />)}
       </div>
            </div>
            {/* Checkout final  */}
            <div className="payment__section">
            <div className="payment__title">
            <h3>Payment method</h3>
            </div>
<div className="payment__details">
{/* Stripe payment method */}
{/* <form onSubmit={handleSubmit}> */}
{/* <CardElement onChange={handleChange} /> */}

</div>
            </div>
            </div>
        </div>
    )
}

export default Payment
